export default __webpack_public_path__ + "static/media/Carport.b4f7c1f8.svg";